import i18n from 'i18next';
import HttpBackend from 'i18next-http-backend';

import { localesSupportedMapped } from '@/assets/js/utilities/countries';

import US from '@/assets/translationFiles/EN.json';
import FR from '@/assets/translationFiles/FR.json';
import ES from '@/assets/translationFiles/ES.json';
import DE from '@/assets/translationFiles/DE.json';
import IT from '@/assets/translationFiles/IT.json';
import NL from '@/assets/translationFiles/NL.json';
import SV from '@/assets/translationFiles/SV.json';
import CS from '@/assets/translationFiles/CS.json';
import PL from '@/assets/translationFiles/PL.json';
import formats from '@/assets/translationFiles/formats.json';

const getDefaultLanguage = () => {
  let unparsedLocale = new URLSearchParams(window.location.search).get('lang');
  if (unparsedLocale) {
    return unparsedLocale;
  }

  if (localStorage.getItem('locale')) {
    unparsedLocale = localStorage.getItem('locale');
  }
  return localesSupportedMapped[unparsedLocale] || unparsedLocale || 'EN';
};

const takeFilesFromBE = localStorage.getItem('translationsBE');
i18n.use(HttpBackend).init({
  ...(takeFilesFromBE
    ? {
        backend: {
          loadPath: '/v1/public/translation/{{lng}}',
          parse: function (data, lng) {
            const env = window.location.hostname.split('.')[0];
            const isNotProd = ['localhost', 'dev', 'sandbox'].includes(env);

            const { keys, ...rest } = JSON.parse(data).translation;
            let allValues = {};
            Object.values(rest).forEach((item) => {
              const temp = {};
              Object.entries(item).forEach(([key, value]) => {
                temp[key] = !value
                  ? `${isNotProd && lng !== 'EN' ? '(' + lng + ')' : ''}${key}`
                  : value;
              });
              allValues = { ...allValues, ...temp };
            });
            return { ...formats?.formats, ...allValues };
          },
        },
        load: 'languageOnly',
        preload: ['EN', 'FR', 'DE', 'ES', 'IT', 'NL', 'PL', 'SV', 'CS'],
      }
    : {
        resources: {
          EN: { translation: { ...formats?.formats, ...US } },
          FR: { translation: { ...formats?.formats, ...FR } },
          IT: { translation: { ...formats?.formats, ...IT } },
          ES: { translation: { ...formats?.formats, ...ES } },
          DE: { translation: { ...formats?.formats, ...DE } },
          NL: { translation: { ...formats?.formats, ...NL } },
          PL: { translation: { ...formats?.formats, ...PL } },
          SV: { translation: { ...formats?.formats, ...SV } },
          CS: { translation: { ...formats?.formats, ...CS } },
        },
      }),
  lng: getDefaultLanguage(),
  keySeparator: false,
  nsSeparator: '::',
  interpolation: {
    escapeValue: false,
    format(value, format, lng) {
      switch (format) {
        case 'date':
          if (value.hasOwnProperty('date') && value.hasOwnProperty('timeZone')) {
            return new Intl.DateTimeFormat(lng, {
              timeZone: value.timeZone,
            }).format(value.date);
          }
          break;
        case 'longDate':
          if (value.hasOwnProperty('date') && value.hasOwnProperty('timeZone')) {
            return new Intl.DateTimeFormat(lng, {
              timeZone: value.timeZone,
              year: 'numeric',
              month: 'short',
              day: 'numeric',
            }).format(value.date);
          }
          break;
        case 'number':
          if (!isNaN(value)) {
            return new Intl.NumberFormat(lng).format(value);
          }
          if (value.hasOwnProperty('number') && value.hasOwnProperty('currency')) {
            return new Intl.NumberFormat(lng, {
              style: 'currency',
              currency: value.currency,
            }).format(value.number);
          }
          break;

        case 'time':
          if (value.hasOwnProperty('time') && value.hasOwnProperty('timeZone')) {
            return new Intl.DateTimeFormat(lng, {
              hour: 'numeric',
              minute: 'numeric',
              second: 'numeric',
              timeZone: value.timeZone,
              timeZoneName: 'short',
            }).format(value.time);
          }
          break;
        default:
          return value;
      }
    },
  },
  react: {
    transSupportBasicHtmlNodes: true,
    transKeepBasicHtmlNodesFor: ['h3', 'p', 'ul', 'li', 'br'],
  },
  fallbackLng: false,
});

export default i18n;
